<div class="container-time-table" *ngIf="toggle">
  <div class="close-background" (click)="onToggleClick()"></div>
  <div class="time-table">
    <div class="time-table-header">
      <button class="add-button" (click)="toggleForm()"><fa-icon [icon]="faPlus"></fa-icon></button>
      <h3 class="titulo">Time Table</h3>
    </div>
    <div class="divisao"></div>

    <table class="content-table">
      <thead>
        <tr>
          <th>Viagem</th>
          <th>Tipo</th>
          <th>Destino</th>
          <th>Início LCB</th>
          <th>Saída LCB</th>
          <th>Início SLA </th>
          <th>Saída SLA</th>
          <th>TAKT</th>
          <th>TAKT (Extra)</th>
          <th>Ações</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let viagem of data">
            <td>{{ viagem.viagem }}</td>
            <td>{{ viagem.tipo }}</td>
            <td>{{ viagem.destino }}</td>
            <td>{{ viagem.inicioLCB }}</td>
            <td>{{ viagem.saidaLCB }}</td>
            <td>{{ viagem.inicioSLA }}</td>
            <td>{{ viagem.saidaSLA }}</td>
            <td>{{ calculateDifference(viagem.inicioLCB, viagem.saidaLCB) }}</td>
            <td>{{ viagem.extra}}</td>
            <td>
              <div class="actions">
                <button class="edit" (click)="openEditForm(viagem)"><fa-icon [icon]="faPen"></fa-icon></button>
                <button class="delete" (click)="deleteTripById(viagem.viagem)"><fa-icon
                    [icon]="faTrash"></fa-icon></button>
              </div>
            </td>
        </tr>
      </tbody>

    </table>
  </div>

  <app-time-table-form *ngIf="showForm" class="overlay" (closeForm)="toggleForm()" (dataUpdated)="onDataUpdated()" [receivedTrip]="tripToEdit"></app-time-table-form>
</div>
